(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fibes-pdp-review-cards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fibes-review-carousel')) {
    customElements.define('fibes-review-carousel', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('.fibes-pdp-reviews__track');
        const previous = this.querySelector('[data-direction="-1"]');
        const next = this.querySelector('[data-direction="1"]');
        const updateArrows = () => {
          previous.disabled = track.scrollLeft <= 1;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
        };

        for (const button of [previous, next]) {
          button.addEventListener('click', () => {
            const card = track.querySelector('.fibes-pdp-reviews__card');
            track.scrollBy({ left: (card.offsetWidth + 8) * Number(button.dataset.direction), behavior: 'smooth' });
          });
        }

        track.addEventListener('scroll', updateArrows, { passive: true });
        updateArrows();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fibes-variant-cards"] && !Shopify.designMode) return;
  try {
    class FibesVariantCards extends HTMLElement {
    connectedCallback() {
      if (this.dataset.fvcConnected === 'true') return;
      this.dataset.fvcConnected = 'true';
      this.abortController = new AbortController();
      this.initialize = this.initialize.bind(this);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.initialize, {
          once: true,
          signal: this.abortController.signal,
        });
      } else {
        requestAnimationFrame(this.initialize);
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.formObserver?.disconnect();
      this.restoreNativePicker();

      if (this.planInput?.parentElement === this.form) {
        this.planInput.remove();
      }
      if (this.unitsInput?.parentElement === this.form) {
        this.unitsInput.remove();
      }

      delete this.dataset.fvcConnected;
      delete this.dataset.fvcReady;
    }

    initialize() {
      if (!this.isConnected || this.dataset.fvcReady === 'true') return;

      this.section = this.closest('.shopify-section');
      this.cards = Array.from(this.querySelectorAll('[data-fvc-card]'));
      this.modeInputs = Array.from(this.querySelectorAll('[data-fvc-mode]'));
      this.variantInputs = Array.from(this.querySelectorAll('[data-fvc-variant]'));
      this.statusElement = this.querySelector('[data-fvc-status]');
      this.planInput = this.querySelector('[data-fvc-selling-plan]');
      this.unitsInput = this.querySelector('[data-fvc-units-per-variant]');
      this.currentVariantId = this.dataset.currentVariantId || '';
      this.mode = this.dataset.initialMode || 'one-time';

      const formCandidate = document.getElementById(this.dataset.formId || '');
      const optionCount = Number.parseInt(this.dataset.optionCount || '0', 10);
      const variantCount = Number.parseInt(this.dataset.variantCount || '0', 10);

      if (!(formCandidate instanceof HTMLFormElement) || !this.section?.contains(formCandidate)) {
        this.fail();
        return;
      }

      this.form = formCandidate;

      const matchingPickers = Array.from(this.section.querySelectorAll('variant-picker')).filter(
        (picker) => picker instanceof HTMLElement && picker.dataset.productId === this.dataset.productId
      );

      if (optionCount > 1 || (variantCount > 1 && matchingPickers.length !== 1)) {
        this.fail();
        return;
      }

      this.nativePicker = matchingPickers[0] || null;

      if (
        !(this.planInput instanceof HTMLInputElement) ||
        !(this.unitsInput instanceof HTMLInputElement) ||
        this.hasForeignSellingPlanInput()
      ) {
        this.fail();
        return;
      }

      this.form.append(this.planInput);
      this.form.append(this.unitsInput);

      if (this.nativePicker) {
        this.nativePickerWasHidden = this.nativePicker.hidden;
        this.nativePickerAriaHidden = this.nativePicker.getAttribute('aria-hidden');
        this.nativePicker.hidden = true;
        this.nativePicker.setAttribute('aria-hidden', 'true');
      }

      this.addEventListener('change', this.handleChange.bind(this), { signal: this.abortController.signal });
      this.section.addEventListener('variant:update', this.handleVariantUpdate.bind(this), {
        signal: this.abortController.signal,
      });

      this.formObserver = new MutationObserver(() => {
        if (this.hasForeignSellingPlanInput()) this.fail();
      });
      this.formObserver.observe(this.form, { childList: true, subtree: true });

      this.dataset.fvcReady = 'true';
      this.updateModeAvailability();
      this.render();
      this.syncSellingPlan(true);
    }

    hasForeignSellingPlanInput() {
      if (!this.form) return false;
      return Array.from(this.form.elements).some(
        (element) => element instanceof HTMLInputElement && element.name === 'selling_plan' && element !== this.planInput
      );
    }

    handleChange(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;

      if (target.matches('[data-fvc-mode]')) {
        this.mode = target.value;
        this.render();
        this.syncSellingPlan();
        this.trackPurchaseModeSelection();
        return;
      }

      if (!target.matches('[data-fvc-variant]')) return;

      const variantId = target.value;
      if (!variantId || variantId === this.currentVariantId) {
        this.render();
        return;
      }

      const nativeTarget = this.findNativeVariantControl(variantId);
      if (!nativeTarget) {
        this.fail();
        return;
      }

      this.dataset.fvcBusy = 'true';
      this.setAttribute('aria-busy', 'true');
      this.pendingVariantId = variantId;
      this.render();

      if (nativeTarget instanceof HTMLInputElement) {
        nativeTarget.checked = true;
        nativeTarget.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (nativeTarget instanceof HTMLOptionElement) {
        const select = nativeTarget.closest('select');
        if (!(select instanceof HTMLSelectElement)) {
          this.fail();
          return;
        }
        select.value = nativeTarget.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    handleVariantUpdate(event) {
      const detail = event.detail;
      if (!detail?.resource?.id) return;
      if (detail.data?.productId && String(detail.data.productId) !== String(this.dataset.productId)) return;

      const nextVariantId = String(detail.resource.id);
      if (this.pendingVariantId && nextVariantId !== this.pendingVariantId) return;
      const wasUserSelection = Boolean(this.pendingVariantId);
      const nextInput = this.variantInputs.find((input) => input.value === nextVariantId);
      if (!nextInput) {
        this.fail();
        return;
      }

      this.currentVariantId = nextVariantId;
      this.dataset.currentVariantId = nextVariantId;
      this.pendingVariantId = '';
      nextInput.checked = true;
      delete this.dataset.fvcBusy;
      this.removeAttribute('aria-busy');
      this.updateModeAvailability();
      this.render();
      this.syncSellingPlan();
      if (wasUserSelection) this.trackVariantSelection();
    }

    findNativeVariantControl(variantId) {
      if (!this.nativePicker) return null;
      return Array.from(this.nativePicker.querySelectorAll('[data-variant-id]')).find(
        (control) => control instanceof HTMLElement && control.dataset.variantId === variantId
      );
    }

    findCard(variantId) {
      return this.cards.find((card) => card instanceof HTMLElement && card.dataset.variantId === variantId) || null;
    }

    updateModeAvailability() {
      const card = this.findCard(this.currentVariantId);
      if (!card) return;

      const hasSubscription = Boolean(card.dataset.planId);
      const requiresSellingPlan = card.dataset.requiresSellingPlan === 'true';
      const subscriptionInput = this.modeInputs.find((input) => input.value === 'subscription');
      const oneTimeInput = this.modeInputs.find((input) => input.value === 'one-time');

      if (subscriptionInput) subscriptionInput.disabled = !hasSubscription;
      if (oneTimeInput) oneTimeInput.disabled = requiresSellingPlan;

      if (this.mode === 'subscription' && !hasSubscription && !requiresSellingPlan) {
        this.mode = 'one-time';
        this.announce(this.dataset.subscriptionUnavailable || '');
      } else if (this.mode === 'one-time' && requiresSellingPlan && hasSubscription) {
        this.mode = 'subscription';
      } else if (requiresSellingPlan && !hasSubscription) {
        this.announce(this.dataset.subscriptionUnavailable || '');
      } else {
        this.announce('');
      }

      const activeModeInput = this.modeInputs.find((input) => input.value === this.mode);
      if (activeModeInput) activeModeInput.checked = true;
    }

    render() {
      const subscriptionMode = this.mode === 'subscription';
      const displayedVariantId = this.pendingVariantId || this.currentVariantId;
      this.dataset.mode = this.mode;
      this.setHidden(this.querySelector('[data-fvc-mode-note]'), !subscriptionMode);

      this.cards.forEach((card) => {
        if (!(card instanceof HTMLElement)) return;

        const hasSubscription = Boolean(card.dataset.planId);
        const useSubscription = subscriptionMode && hasSubscription;
        const price = useSubscription ? card.dataset.subscriptionPrice : card.dataset.oneTimePrice;
        const priceCents = Number.parseInt(
          useSubscription ? card.dataset.subscriptionPriceCents || '0' : card.dataset.oneTimePriceCents || '0',
          10
        );
        const compareAtCents = Number.parseInt(card.dataset.compareAtPriceCents || '0', 10);
        const perPouch = useSubscription ? card.dataset.subscriptionPerPouch : card.dataset.oneTimePerPouch;
        const savings = useSubscription ? card.dataset.subscriptionSave : card.dataset.oneTimeSave;
        const deliveryValue = useSubscription ? card.dataset.subscriptionDelivery : card.dataset.oneTimeDelivery;
        const billingLabel = useSubscription
          ? this.dataset.subscriptionBillingLabel || ''
          : this.dataset.oneTimeBillingLabel || '';
        const selected = card.dataset.variantId === displayedVariantId;

        this.setText(card.querySelector('[data-fvc-price]'), perPouch || price || '');
        this.setText(card.querySelector('[data-fvc-strike]'), card.dataset.compareAtPrice || '', compareAtCents <= priceCents);
        this.setText(card.querySelector('[data-fvc-save]'), savings || '', !savings);
        this.setText(card.querySelector('[data-fvc-billing-label]'), billingLabel);
        this.setText(card.querySelector('[data-fvc-total-price]'), price || '');
        this.setText(card.querySelector('[data-fvc-delivery-value]'), deliveryValue || '');
        this.setHidden(card.querySelector('[data-fvc-plan-note]'), !subscriptionMode || hasSubscription);

        const details = card.querySelector('[data-fvc-details]');
        details?.setAttribute('aria-hidden', selected ? 'false' : 'true');
      });
    }

    syncSellingPlan(force = false) {
      if (!(this.planInput instanceof HTMLInputElement) || !(this.unitsInput instanceof HTMLInputElement)) return;
      const card = this.findCard(this.currentVariantId);
      if (!card) return;

      const nextValue = this.mode === 'subscription' ? card.dataset.planId || '' : '';
      const nextUnits = Math.max(1, Number.parseInt(card.dataset.unitsPerVariant || '1', 10) || 1);
      const changed = this.planInput.value !== nextValue;
      this.planInput.value = nextValue;
      this.unitsInput.value = String(nextUnits);

      if (changed || force) {
        this.planInput.dispatchEvent(new Event('input', { bubbles: true }));
        this.planInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const mustBlockForm = card.dataset.requiresSellingPlan === 'true' && !nextValue;
      queueMicrotask(() => this.setFormBlocked(mustBlockForm));
    }

    analyticsProperties() {
      const card = this.findCard(this.currentVariantId);
      if (!card) return null;

      const purchaseMode = this.mode === 'subscription' ? 'subscription' : 'one_time';
      const properties = {
        product_id: String(this.dataset.productId || ''),
        product_variant_id: String(this.currentVariantId || ''),
        purchase_mode: purchaseMode,
        units_per_variant: Math.max(1, Number.parseInt(card.dataset.unitsPerVariant || '1', 10) || 1),
      };

      if (purchaseMode === 'subscription' && card.dataset.planId) {
        properties.selling_plan_id = String(card.dataset.planId);
      }
      return properties;
    }

    trackVariantSelection() {
      const properties = this.analyticsProperties();
      if (properties && typeof window.fibesTrack === 'function') {
        window.fibesTrack('fibes_product_variant_selected', properties);
      }
    }

    trackPurchaseModeSelection() {
      const properties = this.analyticsProperties();
      if (properties && typeof window.fibesTrack === 'function') {
        window.fibesTrack('fibes_product_purchase_mode_selected', properties);
      }
    }

    setFormBlocked(blocked) {
      if (!this.form) return;
      const submitButton = this.form.querySelector('[type="submit"][name="add"]');
      if (!(submitButton instanceof HTMLButtonElement)) return;

      if (blocked && !submitButton.disabled) {
        submitButton.dataset.fvcPlanDisabled = 'true';
        submitButton.disabled = true;
      } else if (!blocked && submitButton.dataset.fvcPlanDisabled === 'true') {
        delete submitButton.dataset.fvcPlanDisabled;
        submitButton.disabled = false;
      }
    }

    setText(element, value, hidden = false) {
      if (!(element instanceof HTMLElement)) return;
      element.textContent = value;
      this.setHidden(element, hidden);
    }

    setHidden(element, hidden) {
      if (!(element instanceof HTMLElement)) return;
      element.hidden = Boolean(hidden);
    }

    announce(message) {
      if (this.statusElement) this.statusElement.textContent = message;
    }

    fail() {
      this.formObserver?.disconnect();
      this.abortController?.abort();
      this.dataset.fvcFailed = 'true';
      delete this.dataset.fvcReady;
      delete this.dataset.fvcBusy;
      this.removeAttribute('aria-busy');
      this.querySelectorAll('input').forEach((input) => {
        input.disabled = true;
      });

      if (this.planInput instanceof HTMLInputElement) {
        this.planInput.disabled = true;
        if (this.planInput.parentElement === this.form) this.planInput.remove();
      }

      this.restoreNativePicker();
      this.announce(this.dataset.setupError || '');
    }

    restoreNativePicker() {
      if (!this.nativePicker) return;
      this.nativePicker.hidden = Boolean(this.nativePickerWasHidden);

      if (this.nativePickerAriaHidden === null || this.nativePickerAriaHidden === undefined) {
        this.nativePicker.removeAttribute('aria-hidden');
      } else {
        this.nativePicker.setAttribute('aria-hidden', this.nativePickerAriaHidden);
      }
    }
  }

  if (!customElements.get('fibes-variant-cards')) {
    customElements.define('fibes-variant-cards', FibesVariantCards);
  }
  } catch(e) { console.error(e); }
})();

})();
